import {
  FETCH_INK_MANUFACTURERS,
  FETCH_INK_MANUFACTURERS_FULFILLED,
  FETCH_INK_MANUFACTURERS_REJECTED,
  FETCH_INK_MODELS,
  FETCH_INK_MODELS_FULFILLED,
  FETCH_INK_MODELS_REJECTED,
  TOGGLE_INK_WIDGET,
} from 'b2b-apps/shop/catalog/redux/inkFinder/actionTypes';
import {
  FetchInkManufacturersAction,
  FetchInkManufacturersFulfilledAction,
  FetchInkManufacturersRejectedAction,
  FetchInkModelsAction,
  FetchInkModelsFulfilledAction,
  FetchInkModelsRejectedAction,
  InkManufacturersType,
  InkModelsType,
  ToggleInkWidgetAction,
} from 'b2b-apps/shop/catalog/redux/inkFinder/types';

const fetchInkManufacturers = (): FetchInkManufacturersAction => ({
  type: FETCH_INK_MANUFACTURERS,
});

const fetchInkManufacturersFulfilled = (
  response: InkManufacturersType,
): FetchInkManufacturersFulfilledAction => ({
  type: FETCH_INK_MANUFACTURERS_FULFILLED,
  payload: {
    data: response,
  },
});

const fetchInkManufacturersRejected = (
  error: ErrorType,
): FetchInkManufacturersRejectedAction => ({
  type: FETCH_INK_MANUFACTURERS_REJECTED,
  payload: {
    error,
  },
});

const fetchInkModels = (
  query: string,
): FetchInkModelsAction => ({
  type: FETCH_INK_MODELS,
  payload: {
    query,
  },
});

const fetchInkModelsFulfilled = (
  response: InkModelsType,
): FetchInkModelsFulfilledAction => ({
  type: FETCH_INK_MODELS_FULFILLED,
  payload: {
    data: response,
  },
});

const fetchInkModelsRejected = (
  error: ErrorType,
): FetchInkModelsRejectedAction => ({
  type: FETCH_INK_MODELS_REJECTED,
  payload: {
    error,
  },
});

const toggleInkWidget = (
  isOpen: boolean,
): ToggleInkWidgetAction => ({
  type: TOGGLE_INK_WIDGET,
  payload: {
    isOpen,
  },
});

export {
  fetchInkManufacturers,
  fetchInkManufacturersFulfilled,
  fetchInkManufacturersRejected,
  fetchInkModels,
  fetchInkModelsFulfilled,
  fetchInkModelsRejected,
  toggleInkWidget,
};
